"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokenFileCard = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Paper_1 = require("@jsonjoy.com/ui/lib/4-card/Paper");
const FileIcon_1 = require("@jsonjoy.com/ui/lib/1-inline/FileIcon");
const FileListItem_1 = tslib_1.__importDefault(require("@jsonjoy.com/ui/lib/3-list-item/FileListItem"));
const VoidSelectionOverlay_1 = require("../VoidSelectionOverlay");
const BrokenFileCard = ({ thingId, selected }) => {
    return (React.createElement(Paper_1.Paper, { noOutline: true, round: true, style: {
            margin: '4px 0',
            position: 'relative',
            userSelect: 'none',
        } },
        React.createElement(FileListItem_1.default, { fill: true, spacious: true, icon: React.createElement(FileIcon_1.FileIcon, { label: '404', ext: "txt", size: 32 }), title: 'Missing file', metadata: `Reference ${thingId} could not be resolved` }),
        React.createElement(VoidSelectionOverlay_1.VoidSelectionOverlay, { selected: selected })));
};
exports.BrokenFileCard = BrokenFileCard;
